import GlobalStyles from './prebuilt/GlobalStyles';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import getConfig from '../../../aws-config';
import React from 'react';

// Learning
// To best leverage Stripe’s advanced fraud functionality,
// include this script on every page, not just the checkout page.
// This allows Stripe to detect anomalous behavior that may be indicative
// of fraud as customers browse your website.
// Note: This is why we are adding it to a Layout component.
const config = getConfig();
const stripePromise = loadStripe(config.stripe_publishable_key);

// TIP
// call loadStripe outside of a component
// in that way there's no chance it will get
// called more times than it needs to

const Layout = ({ children, title }: any) => {
  return (
    <>
      <GlobalStyles />
      <Elements stripe={stripePromise}>{children}</Elements>
    </>
  );
};

export default Layout;
